import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { safeText } from "../utils/hubHelpers";

const STATUS_OPTIONS = [
  { value: "Operational", label: "Operational (Active & Available)", color: "#10b981" },
  { value: "Breakdown", label: "Breakdown (Immediate Repair Needed)", color: "#ef4444" },
  { value: "Under Service", label: "Under Service (Scheduled Maintenance)", color: "#f59e0b" },
  { value: "Idle", label: "Idle (Parked / Standby)", color: "#64748b" },
];

export default function QuickStatusModal({ isOpen, toggle, machine, onSuccess }) {
  const [selectedStatus, setSelectedStatus] = useState(machine?.status || "Operational");
  const [loading, setLoading] = useState(false);

  // Sync selected status when machine changes
  React.useEffect(() => {
    if (machine) {
      setSelectedStatus(machine.status || "Operational");
    }
  }, [machine]);

  const handleUpdate = async () => {
    if (!machine?.id) return;
    setLoading(true);
    try {
      const res = await callApi(`${apiUrl.update_machinery}?machineryId=${machine.id}`, {
        method: "POST",
        data: {
          status: selectedStatus,
        },
      });

      if (res?.status === true) {
        toast.success(`Status updated to ${selectedStatus}!`);
        toggle();
        onSuccess?.();
      } else {
        toast.error(res?.message || "Failed to update status");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader
        toggle={toggle}
        close={
          <button
            type="button"
            className="btn-close btn-close-white"
            onClick={toggle}
            aria-label="Close"
            style={{ filter: "invert(1) grayscale(100%) brightness(200%)", opacity: 0.9, cursor: "pointer" }}
          />
        }
        style={{ background: "#0f172a", color: "#fff", display: "flex", alignItems: "center", justifyContent: "space-between" }}
      >
        ⚡ Change Status: {safeText(machine?.name, "Machine")}
      </ModalHeader>
      <ModalBody>
        <p style={{ color: "#475569", marginBottom: "1rem", lineHeight: 1.5 }}>
          Select the new operational state for <strong style={{ color: "#0f172a" }}>{safeText(machine?.name, "Machine")}</strong> ({safeText(machine?.assetNo, "N/A")}):
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
          {STATUS_OPTIONS.map((opt) => (
            <label
              key={opt.value}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.75rem",
                padding: "0.65rem 0.95rem",
                borderRadius: 7,
                border: `1.5px solid ${selectedStatus === opt.value ? opt.color : "#e2e8f0"}`,
                background: selectedStatus === opt.value ? `${opt.color}10` : "#fff",
                cursor: "pointer",
                transition: "all 0.15s ease",
              }}
            >
              <input
                type="radio"
                name="machineStatus"
                value={opt.value}
                checked={selectedStatus === opt.value}
                onChange={() => setSelectedStatus(opt.value)}
                style={{ accentColor: opt.color, width: 17, height: 17 }}
              />
              <span style={{ fontWeight: 600, fontSize: "13.5px", color: "#0f172a" }}>
                {opt.label}
              </span>
            </label>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleUpdate} disabled={loading} style={{ background: "#2563eb", borderColor: "#2563eb" }}>
          {loading ? "Updating..." : "Update Status"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
